import { CancelablePromise } from 'api/request/cancelable-promise';

type Payload = {
  referenceSave: () => CancelablePromise<number>;
  everbeatSave: () => CancelablePromise<number>;
};

type Response = {
  everbeatIndex: number;
  referenceIndex: number;
};

const randomSaveEcgIndex = async ({ referenceSave, everbeatSave }: Payload): Promise<Response> => {
  const isEverbeatFirst = Math.random() < 0.5;
  const [firstSave, secondSave] = isEverbeatFirst ? [everbeatSave, referenceSave] : [referenceSave, everbeatSave];

  const [firstIndex, secondIndex] = await Promise.all([firstSave(), secondSave()]);

  return {
    everbeatIndex: isEverbeatFirst ? firstIndex : secondIndex,
    referenceIndex: isEverbeatFirst ? secondIndex : firstIndex,
  };
};

export { randomSaveEcgIndex };
